import { Typography } from '@mui/material';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  lables: {
    fontSize: '13px !important',
    fontWeight: '500',
    color: '#333333',
    marginRight: '20px',
  },
}));
export const Billable = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const billable = useWatch<string>({ name: 'billableToClient' });
  const { register } = useFormContext();
  register('billable');

  return (
    <>
      <Typography component="span" className={classes.lables}>
        {t('placement.placementMods.billableToClient')}
      </Typography>
      <Typography component="span">{billable}</Typography>
    </>
  );
};
